
// export const SERVER_ADDRESS = 'http://localhost:3880/api/v1/'
export const SERVER_ADDRESS = 'https://aquacole-backend.cybexai-server.com/api/v1/'
